// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"91c79a4e","467":"6f0aa857","577":"bac6b266"}[chunkId] + ".chunk.js";
};